import { combineReducers } from 'redux';
import { rep } from '@breezeway/brzw-react-core';

export default combineReducers({
  schedule: rep.reducersV4.schedule,
  history: rep.reducersV4.history,
  tasks: rep.reducersV4.tasks,
  taskEntities: rep.reducersV4.taskEntities,
  currentTaskId: rep.reducersV4.currentTaskId,
  templates: rep.reducersV4.templates,
  templateEntities: rep.reducersV4.templateEntities,
  properties: rep.reducersV4.properties,
  propertyEntities: rep.reducersV4.propertyEntities,
  supplies: rep.reducersV4.supplies,
  offlineIdMapping: rep.reducersV4.offlineIdMapping,
});
